
import { EnumReduces, TypeControllers, TypeServices } from "../redux/type";
import { EndpointSetting, EnumEndpointsName, EnumMethod } from "@/constants/app/type";
import baseAxios from "./baseAxios";
import { serialize } from "object-to-formdata";
import { userEndpoints } from "../redux/features/user/endpoints";
import { flightEnpoints } from "../redux/features/flight/endpoints";
import { hotelEnpoints } from "../redux/features/hotel/endpoints";
import { bookingEnpoints } from "../redux/features/booking/endpoints";
import { voucherEndpoints } from "../redux/features/voucher/endpoints";
import { blogEndpoints } from "../redux/features/blog/endpoints";
import { tourEnpoints } from "../redux/features/tour/endpoints";
import { esimEndpoints } from "../redux/features/esim/endpoints";

export var endpoints = {
  [EnumReduces.USER]: userEndpoints,
  [EnumReduces.FLIGHT]: flightEnpoints,
  [EnumReduces.HOTEL]: hotelEnpoints,
  [EnumReduces.BOOKING]: bookingEnpoints,
  [EnumReduces.VOUCHER]: voucherEndpoints,
  [EnumReduces.BLOG]: blogEndpoints,
  [EnumReduces.TOUR]: tourEnpoints,
  [EnumReduces.ESIM]: esimEndpoints,
  [EnumReduces.GLOBAL]: {}
}

export const controllers: TypeControllers = Object.values(EnumReduces).reduce(
  (controllersReduced: any, reducerName) => {
    const endpointsOfReducer = Object.entries((endpoints || {})[reducerName] || {})

    for (let i = 0; i < endpointsOfReducer.length; i++) {
      const [endpointName] = endpointsOfReducer[i] as [EnumEndpointsName, EndpointSetting];
      controllersReduced[endpointName] = new AbortController()
    }

    return controllersReduced
  },
  {} as TypeControllers
)

export const services: TypeServices = Object.values(EnumReduces).reduce(
  (servicesReduced: any, reducerName) => {
    const endpointsOfReducer = Object.entries((endpoints || {})[reducerName] || {})

    for (let i = 0; i < endpointsOfReducer.length; i++) {
      const [endpointName, endpointSetting] = endpointsOfReducer[i] as [EnumEndpointsName, EndpointSetting];

      servicesReduced[endpointName] = async ({ params: _params, body: _body }: { params: any, body?: any }, headers?: any) => {
        let response,
          { customEndpoint, ...params } = _params || {},
          { TYPE, ...body } = _body || {}
        let endpoint = customEndpoint ? customEndpoint(endpointSetting.endpoint) : endpointSetting.endpoint
        let _headers = { ...headers }
        const isJson = TYPE === 'JSON'
        const requestConfig = {
          params,
          headers: _headers,
          signal: controllers[endpointName]?.signal,
          attachRootFields: endpointSetting.attachRootFields,
        }

        if (isJson) {
          _headers['Content-Type'] = 'application/json'
        }

        if (endpointSetting.callerService) {
          response = await endpointSetting.callerService(body)
        } else {
          switch (endpointSetting.method) {
            case EnumMethod.GET:
              response = await baseAxios(endpointSetting.api).get(endpoint, requestConfig)
              break;
            case EnumMethod.DEL:
              response = await baseAxios(endpointSetting.api).delete(endpoint, requestConfig)
              break;
            case EnumMethod.POST:
              response = await baseAxios(endpointSetting.api).post(
                endpoint,
                isJson ? JSON.stringify(body) : serialize(body),
                requestConfig
              )
              break;
            case EnumMethod.PUT:
              response = await baseAxios(endpointSetting.api).put(
                endpoint,
                isJson ? JSON.stringify(body) : serialize(body),
                requestConfig
              )
              break;
  
            default:
              break;
          }
        }
        
        return response
      }
    }

    return servicesReduced
  },
  {} as TypeServices
)